import { render } from "./Assurance.vue?vue&type=template&id=61f54402&scoped=true&ts=true"
import script from "./Assurance.vue?vue&type=script&lang=ts"
export * from "./Assurance.vue?vue&type=script&lang=ts"

import "./Assurance.vue?vue&type=style&index=0&id=61f54402&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61f54402"]])

export default __exports__